import React from 'react';
import KeycloakApi from "../lib/keycloak";

export default function OAuthCallback() {
	React.useEffect(() => {
		KeycloakApi.postCallback();
	}, []);

	return <p>Anmeldung abgeschlossen. Dieses Fenster kann geschlossen werden.</p>;
}